import {BaseModel} from '../../shared/entities/base.model';
import {CompanyModel} from './company.model';
import {UserModel} from './user.model';

export class UserProfileModel extends BaseModel {
    user: UserModel;
    company: CompanyModel;
}
